import { useCallback, useEffect, useState } from "react";

// グローバルショートカット（Cmd+K/Ctrl+K）でコマンドパレットを開くカスタムフック
// - open: パレットの開閉状態
// - setOpen: 開閉状態を変更する関数

const useCommandPaletteByKeyPress = () => {
  const [open, setOpen] = useState(false);

  // Cmd+K (Mac) or Ctrl+K (Win/Linux) でパレットを開く
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
      e.preventDefault();
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  return { open, setOpen };
};

export default useCommandPaletteByKeyPress;
